import Stack from "@mui/material/Stack";
import { type FC, type PropsWithChildren, type ReactNode, useState } from "react";
import SimpleDrawer from "../../Drawer/SimpleDrawer";
import TriggerButton, {
	TriggerButtonWithAttention,
} from "../TriggerButton";

export type ICtaPayProps = PropsWithChildren<{
	message: ReactNode;
}>

export const CtaPay: FC<ICtaPayProps> = ({ children, message }) => {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<>
			<TriggerButtonWithAttention
				sx={{ width: "100%" }}
				severity="error"
				onClick={() => { setIsOpen(true); }}
			>
				{children}
			</TriggerButtonWithAttention>
			<SimpleDrawer onClose={() => { setIsOpen(false); }} open={isOpen}>
				<Stack spacing={5}>
					{message}
					<TriggerButton
						onClick={() => { setIsOpen(false); }}
						sx={{ alignSelf: "flex-end" }}
					>
						Rozumím
					</TriggerButton>
				</Stack>
			</SimpleDrawer>
		</>
	);
};

